export const INITIALIZE_POLICYHOLDER_ACTION = 'app/PolicyHolderView/INITIALIZE_POLICYHOLDER_DATA_ACTION';
export const SET_POLICYHOLDER_ACTION = 'app/PolicyHolderView/SET_POLICYHOLDER_ACTION';
export const EDIT_POLICYHOLDER_ACTION = 'app/PolicyHolderView/EDIT_POLICYHOLDER_ACTION';
export const SET_PAYMENTINFO_ACTION = 'app/PolicyHolderView/SET_PAYMENTINFO_ACTION';
export const EDIT_PAYMENTINFO_ACTION = 'app/PolicyHolderView/EDIT_PAYMENT_INFO_ACTION';
export const SET_BENEFICIARIES_ACTION = 'app/PolicyHolderView/SET_BENEFICIARIES_ACTION';
export const EDIT_BENEFICIARIES_ACTION = 'app/PolicyHolderView/EDIT_BENEFICIARIES_ACTION';
export const RESET_STATE_POLICYHOLDER_ACTION = 'app/PolicyHolderView/RESET_STATE_POLICYHOLDER_ACTION';
